import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "CARDS";
export const cardRecordConstants = createCRUDConstants(nameSpace);
